/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserDelegationRequest } from '../../models/create-user-delegation-request';
import { UserDelegationRequestResponse } from '../../models/user-delegation-request-response';

export interface CreateUserDelegationRequest$Params {
      body: CreateUserDelegationRequest
}

export function createUserDelegationRequest(http: HttpClient, rootUrl: string, params: CreateUserDelegationRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDelegationRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, createUserDelegationRequest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDelegationRequestResponse>;
    })
  );
}

createUserDelegationRequest.PATH = '/api/administration/delegations';
